import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconAnchorLink = function IconAnchorLink(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-anchor-link"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7781 9.87875L15.889 13.7678C15.6938 13.9631 15.3772 13.9631 15.1819 13.7678L14.4748 13.0607C14.2795 12.8655 14.2795 12.5489 14.4748 12.3536L18.3639 8.46454L15.5355 5.63611L11.6464 9.5252C11.4511 9.72046 11.1345 9.72046 10.9393 9.5252L10.2322 8.81809C10.0369 8.62283 10.0369 8.30624 10.2322 8.11098L14.1213 4.22189C14.9023 3.44085 16.1686 3.44085 16.9497 4.22189L19.7781 7.05032C20.5592 7.83137 20.5592 9.0977 19.7781 9.87875ZM4.22177 16.9498C3.44072 16.1687 3.44072 14.9024 4.22177 14.1214L8.11086 10.2323C8.30612 10.037 8.6227 10.037 8.81797 10.2323L9.52507 10.9394C9.72034 11.1346 9.72034 11.4512 9.52507 11.6465L5.63599 15.5356L8.46441 18.364L12.3535 14.4749C12.5488 14.2797 12.8653 14.2797 13.0606 14.4749L13.7677 15.182C13.963 15.3773 13.963 15.6939 13.7677 15.8891L9.87863 19.7782C9.09758 20.5593 7.83125 20.5593 7.0502 19.7782L4.22177 16.9498ZM9.58592 13C9.39066 13.1952 9.39066 13.5118 9.58592 13.7071L10.293 14.4142C10.4883 14.6094 10.8049 14.6094 11.0001 14.4142L14.5357 10.8786C14.7309 10.6834 14.7309 10.3668 14.5357 10.1715L13.8286 9.46443C13.6333 9.26916 13.3167 9.26916 13.1215 9.46443L9.58592 13Z",
    fill: "currentColor"
  })));
};

export { IconAnchorLink };
